export enum ApiResources{
    UPLOAD_FILE = 'admin/resources',
    UPLOAD_FILE_SYNC = 'admin/resources/sync',

    /** Biblioteca de medios: GET paginado sobre el mismo path que la subida (verbo distinto). */
    SEARCH_RESOURCES = 'admin/resources',


}
